/**
 * Default: Components
 */

import {
	Button,
	Details,
	Form,
	List,
	MediaGallery,
	Player,
	Slider,
	TabGroup,
	Tag
} from '@ifabnpm/bootstrap/components.js';

import { initRanges } from './shared/form/range/index.js';
import initCalculator from './custom/calculator/index.js';


// ------
// Public
// ------

const index = () => {
	Button.init();
	Details.init();
	// Form.init();
	List.init();
	MediaGallery.init();
	Player.init({
		audio: {
			volume: 0.5
		},
		video: {
			volume: 0.5
		}
	});
	Slider.init();
	TabGroup.init();
	Tag.init();
	initCalculator(); // must run before initRanges() to mark managed elements
	initRanges();
};

// Export
export default index;
